import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import PurchaseInvoiceRegisterForm from '../components/PurchaseInvoiceRegisterForm';
import { useCreatePurchaseInvoiceRegisterHandler } from '../dataHandlers/createPurchaseInvoiceRegisterHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PURCHASE_REGISTER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function CreatePurchaseInvoiceRegisterPage() {
  const { purchaseInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(purchaseInvoiceRegister?.pages?.create_title ?? 'Create Purchase Invoice Register Entry');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  useEffect(() => {
    if (loading) return;
    if (!hasEInvoicePermission(CREATE_PURCHASE_REGISTER)) {
      showActionDeniedSnackbar();
      navigate('/purchase-invoice-register', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  const onRegisterCreated = () => {
    navigate('/purchase-invoice-register');
  };

  const { onSubmit, error, isPending } = useCreatePurchaseInvoiceRegisterHandler({ onSuccess: onRegisterCreated });

  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const onSaveForm = (data) => {
    setIsSubmitting(true);
    onSubmit(data);
  };

  const onCancel = () => {
    navigate('/purchase-invoice-register', { replace: true });
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <PurchaseInvoiceRegisterForm
        initialData={{}}
        onSubmit={onSaveForm}
        onCancel={onCancel}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
